import axios from "axios";
import config from "../../../../config/config";

export const HASHTAGS_LIST = "https://ebus.ir/service/rate/";
export const CREATE_RATING = config.baseUrl + "rating/createRatingByUser";

export const getHashtagsList = (url) => {
  return axios.get(HASHTAGS_LIST + url, {
    //   headers: { Authorization: `Bearer ${token}` },
  });
};

export const createRatingByUser = (data, token) => {
  return axios.post(CREATE_RATING, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};